import { generalConstants } from '@lfx/config/general';

export enum AddContributorCriteria {
  EMAIL_ADDRESS_DOMAIN = 'Email Address Domain' as any,
  EMAIL_ADDRESS = 'Contributor’s Email' as any,
  GITHUB_ORGANIZATION = 'GitHub Organization' as any,
  GITHUB_USERNAME = 'GitHub Username' as any,
  GITLAB_USERNAME = 'GitLab Username' as any,
  GITLAB_GROUP_URL = 'GitLab Group URL' as any,
}

export const AddContributorCriteriaTypes = {
  EMAIL_ADDRESS_DOMAIN: {
    name: AddContributorCriteria.EMAIL_ADDRESS_DOMAIN,
    pattern: generalConstants.domainREgex,
  },
  EMAIL_ADDRESS: {
    name: AddContributorCriteria.EMAIL_ADDRESS,
    pattern: generalConstants.emailRegex,
  },
  GITHUB_ORGANIZATION: {
    name: AddContributorCriteria.GITHUB_ORGANIZATION,
    pattern: '',
  },
  GITHUB_USERNAME: {
    name: AddContributorCriteria.GITHUB_USERNAME,
    pattern: generalConstants.githubUsernameRegex,
  },
  GITLAB_GROUP_URL: {
    name: AddContributorCriteria.GITLAB_GROUP_URL,
    pattern: generalConstants.gitlabGroupRegex,
  },
  GITLAB_USERNAME: {
    name: AddContributorCriteria.GITLAB_USERNAME,
    pattern: generalConstants.gitlabUsernameRegex,
  },
};

export const approvalListKeys = [
  'Domain',
  'Email',
  'GithubOrg',
  'GithubUsername',
  'GitlabOrg',
  'GitlabUsername',
];

export const approvalCriteriaMessage = `Before newly added contributor(s) can start committing code,
they will need to re-click the “Not Covered” button in the EasyCLA message in their pull request,
and then select “Corporate Contributor” and their company.
They will need to do this only once. After completing this selection,
the EasyCLA check will be complete and enabled for all future code contributions for this project.
<br/>
Note: if auto-enable employee acknowledgements is enabled for this CLA Group + Organization, the
contributor(s) will not need to re-click the “Not Covered” button. The contributor(s) will be
automatically approved for this project.`;

export const approvalCriteriaGenericMessage = `
<b>GitHub/GitLab:</b> ${approvalCriteriaMessage}
<br/>
----------------------------------------------------
<br/>
<b>Gerrit:</b> Before newly added contributor(s) can start committing code, they will need to execute the following steps:
<br/>
1. Navigate to Agreements Settings page on Gerrit and click on "New Contributor Agreement" link under Agreements section.
<br/>
2. Select the radio button corresponding to Corporate CLA and click on "Please review the agreement" link.
<br/>
3. And then select “Corporate Contributor” and their company.
<br/>
They will need to do this only once. After completing this selection, the EasyCLA check will be complete and enabled for all future code contributions for this project.
<br/>
----------------------------------------------------
`;

export const githubCriterialMessage = `Only public members of this GitHub organization will be able to commit code as part of this approval list.`;
